import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  NOTIFICATION_TEMPLATES_ADD_PATH,
  NOTIFICATION_TEMPLATES_PATH,
  NOTIFICATION_TEMPLATES_UPDATE_PATH,
} from "utils/constants/paths";

const NotificationTemplates = Loadable(React.lazy(() => import("./View")));
const NotificationTemplatesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate")),
);

export const NotificationTemplatesRoute: IRouteItem = {
  path: NOTIFICATION_TEMPLATES_PATH,
  iconName: "NotificationBing",
  element: React.createElement(NotificationTemplates),
  name: "Notification Templates",
  accessKeys: ["ContentCreator"],
  children: [
    {
      name: "Add / Update",
      path: NOTIFICATION_TEMPLATES_ADD_PATH,
      element: React.createElement(NotificationTemplatesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: NOTIFICATION_TEMPLATES_UPDATE_PATH,
      element: React.createElement(NotificationTemplatesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
